import { createAsyncAction } from "../helpers";
import { createAction } from "redux-actions";

export const getPresetsAsyncAction = createAsyncAction("TOURNAMENT_PRESETS");

export const getResultsAsyncAction = createAsyncAction(
	"GET_TOURNAMENT_RESULTS_REQUEST",
	"GET_TOURNAMENT_RESULTS_SUCCESS",
	"GET_TOURNAMENT_RESULTS_FAILURE",
	"GET_TOURNAMENT_RESULTS_CANCEL"
);

export const createPresetItemAsyncAction = createAsyncAction(
	"CREATE_PRESET_ITEM"
);

export const deletePresetItemAsyncAction = createAsyncAction(
	"DELETE_PRESET_ITEM"
);

export const getTournamentsAsyncAction = createAsyncAction("GET_TOURNAMENTS");

export const getTournamentAsyncAction = createAsyncAction("GET_TOURNAMENT");

export const updateTournamentStatusAsyncAction = createAsyncAction(
	"UPDATE_TOURNAMENT_STATUS"
);

export const updateTournamentResultsAsyncAction = createAsyncAction(
	"UPDATE_TOURNAMENT_RESULTS"
);

export const withdrawTournamentAsyncAction = createAsyncAction(
	"POST_TOURNAMENT_WITHDRAW_REQUEST",
	"POST_TOURNAMENT_WITHDRAW_SUCCESS",
	"POST_TOURNAMENT_WITHDRAW_FAILURE",
	"POST_TOURNAMENT_WITHDRAW_CANCEL"
);

export const joinTournamentAsyncAction = createAsyncAction(
	"POST_TOURNAMENT_JOIN_REQUEST",
	"POST_TOURNAMENT_JOIN_SUCCESS",
	"POST_TOURNAMENT_JOIN_FAILURE",
	"POST_TOURNAMENT_JOIN_CANCEL"
);

export const getTournamentJoinedAsyncAction = createAsyncAction(
	"GET_TOURNAMENT_JOINED"
);

export const deleteTournamentAsyncAction = createAsyncAction(
	"DELETE_TOURNAMENT"
);

export const exportTournamentsDataAsyncAction = createAsyncAction(
	"EXPORT_TOURNAMENTS"
);

export const resetAction = createAction("TOURNAMENTS_RESET_ACTIONS");
